import "./Review.css";
import { Row, Col, ListGroup, Button } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { Link } from "react-router-dom";
import { Rating } from "react-simple-star-rating";
import dayjs from "dayjs";
import { useState, useEffect } from "react";
import { ModalMessage } from "../generalLayout";

export default function Review(props) {
  const review = props.review;

  const [expandText, setExpandText] = useState(false);
  const [showReadMore, setShowReadMore] = useState(false);
  const [showAlertDelete, setShowAlertDelete] = useState({});

  useEffect(() => {
    const handleResizeWindow = () => {
      // on resize, check if comment is truncated. If it is, show ReadMore button
      const commentElement = document.getElementById(`review-text-body-${props?.review?._id}`);
      // offsetHeight = displayed height, scrollHeight = height if fully expanded
      const showReadMore = commentElement.offsetHeight < commentElement.scrollHeight;
      setShowReadMore(showReadMore);
    }
    if(!expandText){

      handleResizeWindow();
      window.addEventListener('resize', handleResizeWindow)
    }
      return () => {
        window.removeEventListener('resize', handleResizeWindow)
      }

  }, [expandText, props?.review?._id])


  const handleConfirmDelete = () => {
    props?.handleDelete(showAlertDelete?.payload);
  }

  return (
    <>
      {/* alert message */}
      {showAlertDelete?.show && 
      <ModalMessage
          message= "Are you sure you want to delete this review? "
          confirmButton={true}
          handleConfirm={handleConfirmDelete}
          setShowAlertMsg={setShowAlertDelete}
        />
      }
    <ListGroup.Item className="mt-4">
      {(props.editable || props.deletable) && (
        <Row>
          <h5>{review?.productName}</h5>
        </Row>
      )}
      <Row>
        <Col sm={9} lg={10}>
          <Rating
            readonly
            size={20}
            initialValue={review?.rating}
            style={{ position: "relative", top: "-3px" }}
          />
          <h6
            style={{ display: "inline-block", marginLeft: "15px" }}
            className="fw-bold"
          >
            {review?.title}
          </h6>
          <p style={{ fontSize: "small", fontWeight: "lighter" }}>
            Reviewed by {`${review?.user?.firstName} ${review?.user?.lastName}`}{" "}
            -{" "}
            {review?.createdAt &&
              dayjs(review.createdAt).format("MMM DD, YYYY")}
          </p>
        </Col>
        <Col sm={3} lg={2} className="review-buttons-group">
          {props.editable ? (
            <>
              <Button
                className="btn-sm"
                variant="warning"
                onClick={() => props.handleEdit(review)}
              >
                <i className="bi bi-pencil-square"></i>
              </Button>
              {"\u00A0\u00A0\u00A0"}
            </>
          ) : null}
          {props.deletable ? (
            <Button
              className="btn-sm "
              variant="danger"
              onClick={() => {
                setShowAlertDelete({show: true, payload: review._id}); 
                }}
            >
              <i className="bi bi-trash3-fill"></i>
            </Button>
          ) : null}
        </Col>
      </Row>
      <div>
        <p
          style={{ marginBottom: "0" }}
          className={`mt-1 ${!expandText && "truncate-lines"} text-block review-comment`}
          id={`review-text-body-${review?._id}`}
        >
          {review?.comment}{" "}
        </p>
        {showReadMore && (
          <Button
            variant="link"
            onClick={() => setExpandText((prevValue) => !prevValue)}
            style={{ padding: "0" }}
          >
            {expandText ? "Read Less" : "Read More"}
          </Button>
        )}
      </div>
      {props.editable || props.deletable ? (
        <LinkContainer to={`/product-details/${review.product}`}>
          <Link>View Product</Link>
        </LinkContainer>
      ) : null}
    </ListGroup.Item>
    </>
  );
}
